/**
 * Locale translations: ru (Russian).
 * Keys and structure are shared across all locale files.
 */
export const ru = {
  // Common
  common: {
    loading: "Загрузка...",
    error: "Ошибка",
    sort: "Сортировка",
    sortAsc: "По возрастанию",
    sortDesc: "По убыванию",
    save: "Сохранить",
    cancel: "Отмена",
    delete: "Удалить",
    remove: "Убрать",
    edit: "Редактировать",
    view: 'Просмотр',
    copy: "Копировать",
    create: "Создать",
    update: "Обновить",
    search: "Поиск",
    actions: "Действия",
    code: "Код",
    all: "Все",
    clear: "Очистить",
    filter: "Фильтр",
    yes: "Да",
    no: "Нет",
    confirm: "Подтвердить",
    close: "Закрыть",
    select: "Выбрать",
    active: "Активен",
    inactive: "Неактивен",
    success: "Успешно",
    updated: "Обновлено",
    created: "Создано",
    deleted: "Удалено",
    confirmDelete: "Вы уверены, что хотите удалить?",
    errorOccurred: "Произошла ошибка",
    noData: "Нет данных",
    status: "Статус",
    show: "Показать",
    hide: "Скрыть",
    searchPlaceholder: "Поиск...",
    allStatuses: "Все статусы",
    clearFilters: "Очистить фильтры",
    newRecord: "Новая запись",
    noPermission: "Нет разрешения",
    statusDistribution: "Распределение статусов",
    rows: "строк",
    firstPage: "Первая страница",
    previousPage: "Предыдущая страница",
    nextPage: "Следующая страница",
    lastPage: "Последняя страница",
    page: "Страница",
    optional: "Необязательно",
    saving: "Сохранение...",
    deleteConfirmTitle: "Подтверждение удаления",
    deleteWarning: "Это действие нельзя отменить!",
    autoTranslate: "Автоперевод",
    autoTranslateSuccessCount: "{count} элементов переведено автоматически.",
    autoTranslateNoSource: "Исходный текст для перевода не найден.",
    enterTargetLanguage: "Пожалуйста, выберите целевой язык.",
    sourceLanguageLabel: "Исходный язык (ваш интерфейс)",
    targetLanguage: "Целевой язык",
    sourceAndTargetMustDiffer: "Исходный и целевой языки должны различаться.",
    context: "Контекст",
    key: "Ключ",
    value: "Значение",
    locale: "Язык",
    auto: "Авто",
    manual: "Вручную",
    manageLocales: "Управление языками",
    activeLocalesDescription: "Выберите активные языки. Сохраняется только как настройка.",
    updateUntranslatedFields: "Синхронизировать новые поля",
    syncEntriesResult: "Синхронизировано {count} новых записей перевода.",
    syncDeletedResult: "Удалено {count} устаревших записей.",
    selectSourceLanguageForSync: "На каком языке этот контент?",
    sourceLanguage: "Исходный язык",
    originalShort: "Ориг.",
    languageNames: { en: "Английский", tr: "Турецкий", de: "Немецкий", fr: "Французский", es: "Испанский", ar: "Арабский", it: "Итальянский", ja: "Японский", zh: "Китайский", ru: "Русский" } as Record<string, string>,
    perPage: "На странице",
    darkMode: "Темная тема",
    lightMode: "Светлая тема",
    copyright: "© {year} QubePro. Все права защищены.",
    translationRates: "Показатели перевода",
    profileMenu: "Меню профиля",
    manageYourAccount: "Управление аккаунтом",
    adminConsole: "Консоль администратора",
    serverConfiguring: "Настройка сервера, пожалуйста, подождите...",
    productName: "Управление",
  },

  portal: {
    searchPlaceholder: "Поиск приложений...",
    noAppsFound: "Приложения не найдены.",
    quickLinks: "Быстрые ссылки",
    console: "Консоль администратора",
    lastLogin: "Последний вход",
    apps: {
      core: { name: "Управление", description: "Управляйте компаниями, организациями, пользователями, ролями и доступами на централизованной платформе." },
      bi: { name: "Аналитика", description: "Создавайте отчеты и дашборды на основе ваших данных. Превращайте бизнес-данные в идеи." },
      bpm: { name: "Процессы", description: "Запускайте, отслеживайте и выполняйте внутренние запросы, согласования и задачи в цифровой среде." },
      support: { name: "Поддержка", description: "Управляйте запросами клиентов и тикетами. Отслеживайте и решайте проблемы в одном месте." },
      agent: { name: "Автоматизация", description: "Автоматизируйте рутинные задачи с помощью ботов и агентов. Интегрируйте ваши инструменты." },
      ai: { name: "ИИ и Прогнозы", description: "Используйте модели ИИ для анализа данных и прогнозирования. Улучшайте планирование и решения." },
      erp: { name: "Бизнес-пакет", description: "Модули для финансов, продаж, склада и операций. Управляйте бизнесом на единой платформе." },
      pms: { name: "Проекты", description: "Планируйте проекты, назначайте задачи, отслеживайте прогресс и работайте в команде." },
      crm: { name: "Клиенты", description: "Управляйте контактами, лидами, сделками и воронками продаж. Вся информация о клиентах в одном месте." },
    },
    menus: {
      core_dashboard: "Дашборд",
      core_companies: "Компании",
      core_organizations: "Организации",
      core_roles: "Роли",
      core_users: "Пользователи",
      core_groups: "Группы",
      core_emails: "Почтовые аккаунты",
      core_data_sources: "Источники данных",
      core_settings_company: "Настройки компании",
      core_settings_user: "Настройки пользователя",
      core_translations: "Переводы",
    },
  },

  panel: {
    apps: {
      crm: { name: "CRM", footerName: "CRM" },
      accounting: { name: "Бухгалтерия" },
      finance: { name: "Финансы" },
      procurement: { name: "Закупки" },
      inventory: { name: "Склад" },
      purchase: { name: "Закупки" },
      sales: { name: "Продажи" },
      manufacturing: { name: "Производство" },
      assets: { name: "Активы" },
      hr: { name: "Кадры" },
      project: { name: "Проекты" },
      timesheet: { name: "Табель учета времени" },
      documents: { name: "Документы" },
      pos: { name: "Точка продаж" },
      rental: { name: "Аренда" },
      dashboard: { name: "Отчеты" },
    },
    appsLabel: "Приложения",
    settingsLabel: "Настройки",
    coreLabel: "Управление",
    backToHome: "На главную",
  },

  errors: {
    unknown: "Произошла неизвестная ошибка",
    network: "Не удалось подключиться к серверу. Проверьте интернет.",
    timeout: "Время ожидания истекло. Пожалуйста, попробуйте снова.",
    badRequest: "Некорректный запрос",
    unauthorized: "Сессия истекла. Пожалуйста, войдите снова.",
    forbidden: "У вас нет разрешений на это действие.",
    notFound: "Ресурс не найден",
    tooManyRequests: "Слишком много запросов. Попробуйте позже.",
    internalServerError: "Ошибка сервера. Попробуйте позже.",
    badGateway: "Сервер временно недоступен",
    serviceUnavailable: "Сервис временно недоступен",
    gatewayTimeout: "Сервер не отвечает",
    serverErrorWithStatus: "Ошибка сервера ({status})",
  },

  // Dashboard
  dashboard: {
    title: "Панель управления",
    subtitle: "Обзор системы централизованного управления",
    welcome: "Добро пожаловать",
    guestName: "Гость",
    statusSummary: "Текущее состояние системы",
    currentTimeLabel: "Текущее время",
    todayLabel: "Сегодня",
    activeCompanies: "Активные компании",
    activeOrganizations: "Активные организации",
    activeUsers: "Активные пользователи",
    activeRoles: "Активные роли",
    database: "База данных",
    databaseUsed: "Занято места",
    recentlyAddedUsers: "Недавно добавленные пользователи",
    recentlyAddedCompanies: "Недавно добавленные компании",
    noUsersYet: "Пользователей пока нет",
    noCompaniesYet: "Компаний пока нет",
    userPanel: "Панель пользователя",
    userPanelWelcome: "Добро пожаловать! Доступ к настройкам пользователя через меню.",
    quickActions: "Быстрые действия",
    systemHealthTitle: "Состояние системы",
    systemLogsTitle: "Системные логи",
    logChartTitle: "Распределение Ошибок/Предупреждений",
    logErrorsLabel: "Ошибки",
    logWarningsLabel: "Предупреждения",
    logSuccessLabel: "Успешно",
    statusHealthy: "Исправен",
    statusFailed: "Сбой",
    statusUnknown: "Неизвестно",
    lastRun: "Последний запуск",
    failures24h: "Сбои за 24ч",
    noData: "Нет данных",
    systemComponents: {
      EMAIL_INGEST: "Входящая почта (IMAP)",
      EMAIL_DISPATCH: "Исходящая почта (SMTP)",
      JOB_SCHEDULER: "Планировщик задач",
      API: "Интерфейс API",
    },
  },

  // Sidebar
  sidebar: {
    dashboard: "Дашборд",
    roles: "Роли",
    users: "Пользователи",
    settings: "Настройки",
    systemSettings: "Системные настройки",
    userSettings: "Настройки пользователя",
    organizations: "Организации",
    logout: "Выйти",
    toggleMenu: "Переключить меню",
    toggleMenuClose: "Закрыть меню",
    management: "Управление",
    companies: "Компании",
    emailAccounts: "Почтовые аккаунты",
    dataSources: "Источники данных",
    translations: "Переводы",
  },

  // Settings
  settings: {
    title: "Настройки",
    subtitle: "Управление настройками компании и пользователя",
    companySettingsSubtitle: "Общие настройки для компании",
    userSettingsSubtitle: "Ваши личные настройки",
    securitySettingsSubtitle: "Управление паролем и безопасностью",
    companySettings: "Настройки компании",
    userSettings: "Настройки пользователя",
    general: "Общие",
    personal: "Личные",
    timezone: "Часовой пояс",
    dateFormat: "Формат даты",
    defaultCurrency: "Валюта по умолчанию",
    defaultLanguage: "Язык по умолчанию",
    language: "Язык",
    companySettingsSaved: "Настройки компании сохранены",
    userSettingsSaved: "Настройки пользователя сохранены",
    failedToLoad: "Не удалось загрузить настройки",
    saveFailed: "Не удалось сохранить настройки",
    profilePicture: "Фото профиля",
    maxFileSize: "Макс 5МБ. Форматы: JPEG, PNG, GIF, WebP",
    change: "Изменить",
    uploading: "Загрузка...",
    deleteAvatar: "Удалить фото",
    deleteAvatarConfirm: "Вы хотите удалить фото профиля?",
    avatarUploaded: "Фото профиля загружено",
    avatarDeleted: "Фото профиля удалено",
    avatarUploadError: "Ошибка при загрузке фото",
    avatarDeleteError: "Ошибка при удалении фото",
    onlyImageFiles: "Разрешены только изображения",
    fileSizeError: "Файл должен быть меньше 5МБ",
    appearance: "Оформление",
    theme: "Тема",
    light: "Светлая",
    dark: "Темная",
    pageSize: "Размер страницы таблицы",
    defaultCompany: "Компания по умолчанию",
    selectDefaultCompany: "Выберите компанию по умолчанию",
    noCompaniesAssigned: "Компании не назначены",
    security: "Безопасность",
    changePassword: "Изменить пароль",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmNewPassword: "Подтвердите новый пароль",
    passwordChanged: "Пароль успешно изменен",
    passwordChangeFailed: "Не удалось изменить пароль",
    passwordMismatch: "Новые пароли не совпадают",
    passwordTooShort: "Пароль должен быть не менее 6 символов",
    passwordSameAsOld: "Новый пароль должен отличаться от текущего",
    changingPassword: "Изменение пароля...",
    pleaseSelectCompany: "Пожалуйста, выберите компанию",
  },

  // Organizations
  organizations: {
    title: "Организации",
    code: "Код",
    name: "Название организации",
    description: "Описание",
    logo: "Логотип",
    logoEmpty: "Нет логотипа",
    uploadLogo: "Загрузить логотип",
    status: "Статус",
    smtp: "SMTP",
    imap: "IMAP",
    smtpEmailAccount: "Аккаунт SMTP",
    imapEmailAccount: "Аккаунт IMAP",
    active: "Активна",
    inactive: "Неактивна",
    newOrganization: "Новая организация",
    editOrganization: "Редактировать организацию",
    deleteConfirm: "Вы хотите удалить эту организацию?",
    deleteFailed: "Не удалось удалить организацию",
    operationFailed: "Операция не удалась",
    failedToLoad: "Не удалось загрузить организации",
    dataFormatError: "Некорректный формат данных организации",
    searchPlaceholder: "Поиск организации (название, описание)",
    empty: "Нет данных",
    notSet: "Не установлено",
    noCreatePermission: "Нет разрешения на создание организации",
    noUpdatePermission: "Нет разрешения на редактирование организации",
    noDeletePermission: "Нет разрешения на удаление организации",
    company: "Название компании",
    statusDistribution: "Распределение статусов организаций",
  },

  // Users
  users: {
    title: "Пользователи",
    newUser: "Новый пользователь",
    editUser: "Редактировать пользователя",
    noUsersYet: "Пользователей пока нет",
    failedToLoad: "Не удалось загрузить пользователей",
    deleteConfirm: "Вы хотите удалить этого пользователя?",
    deleteFailed: "Не удалось удалить пользователя",
    operationFailed: "Операция не удалась",
    passwordRequired: "Пароль обязателен",
    passwordChangeHint: "(Заполните для изменения)",
    fullName: "Полное имя",
    email: "Email",
    status: "Статус",
    roles: "Роли",
    actions: "Действия",
    firstName: "Имя *",
    lastName: "Фамилия *",
    password: "Пароль",
    noRoles: "Нет ролей",
    rolesNotFound: "Роли не найдены",
    statusActive: "Активен",
    statusInactive: "Неактивен",
    statusSuspended: "Заблокирован",
    userInfoFailed: "Ошибка загрузки инфо пользователя",
    rolesFailed: "Ошибка загрузки ролей",
    copy: "Копировать",
    isAdmin: "Админ",
    groups: "Группы",
    groupCount: "Кол-во групп",
    userGroupName: "Название группы",
    userGroupCode: "Код группы",
    userGroupEmail: "Email группы",
    groupManager: "Менеджер группы",
    members: "Участники",
    userGroupDescription: "Описание",
    userGroupCreate: "Создать новую группу",
    userGroupEdit: "Редактировать группу",
    manageMembers: "Управление участниками",
    addMember: "Добавить участника",
    memberCount: "Кол-во участников",
    searchUsers: "Поиск пользователей...",
    noMembers: "Участников пока нет",
    selectUser: "Выбрать пользователя",
    addUser: "Добавить",
    removeUser: "Удалить",
    manageGroups: "Управление группами",
    noUsersFound: "Пользователи не найдены",
    statusDistribution: "Распределение статусов пользователей",
    groupStatusDistribution: "Распределение статусов групп",
  },

  // Roles
  roles: {
    title: "Роли",
    newRole: "Новая роль",
    editRole: "Редактировать роль",
    noRolesYet: "Ролей пока нет",
    failedToLoad: "Не удалось загрузить роли",
    deleteConfirm: "Вы хотите удалить эту роль?",
    deleteFailed: "Не удалось удалить роль",
    operationFailed: "Операция не удалась",
    dataFormatError: "Ошибка формата данных",
    permissionsFailed: "Ошибка загрузки разрешений",
    name: "Название роли *",
    description: "Описание",
    permissions: "Разрешения",
    permissionCount: "Кол-во разрешений",
    type: "Тип роли",
    typeSystem: "Системная",
    typeCustom: "Пользовательская",
    typeAll: "Все роли",
    searchPlaceholder: "Поиск (имя, описание, разрешение)...",
    systemBadge: "Системная",
    permissionsCount: "Разрешения ({count})",
    morePermissions: "+ еще {count}",
    copy: "Копировать",
    copySuffix: " (копия)",
    clearFilters: "Очистить фильтры",
    noCreatePermission: "Нет разрешения на создание роли",
    noUpdatePermission: "Нет разрешения на редактирование роли",
    noDeletePermission: "Нет разрешения на удаление роли",
    systemRoleEditBlocked: "Системные роли нельзя редактировать",
    systemRoleDeleteBlocked: "Системные роли нельзя удалять",
    noPermissions: "Нет разрешений",
    paginationRange: "{start}-{end} из {total}",
    paginationPage: "Страница {page} / {total}",
    modules: {
      users: "Пользователи",
      groups: "Группы",
      userGroupName: "Название группы",
      userGroupCode: "Код группы",
      groupManager: "Менеджер группы",
      members: "Участники",
      userGroupDescription: "Описание",
      userGroupCreate: "Создать новую группу",
      userGroupEdit: "Редактировать группу",
      roles: "Роли",
      tenant: "Тенент",
      userSettingField: "Настройка",
      settings: "Настройки",
      organizations: "Организации",
    },
    groups: "Группы",
    userGroup: "Группа",
    userGroupList: "Список групп",
    userGroupCreate: "Создать группу",
    userGroupEdit: "Редактировать группу",
    userGroupName: "Название группы",
    userGroupDescription: "Описание",
    userGroupCode: "Код",
    groupManager: "Менеджер группы",
    members: "Участники",
    addMember: "Добавить участника",
    assignRole: "Назначить роль",
    assign: "Назначить",
    statusDistribution: "Распределение статусов ролей",
    assignRoleMatrix: "Матрица ролей",
    roleMatrix: "Матрица ролей",
    selectCompanyToViewMatrix: "Выберите компанию для матрицы",
    show: "Показать",
    hide: "Скрыть",
    searchPermissions: "Поиск разрешений...",
    permission: "Разрешение",
    permissionsSelected: "Выбрано {count} разрешений",
  },

  // Companies
  companies: {
    title: "Компании",
    newCompany: "Новая компания",
    editCompany: "Редактировать компанию",
    noCompaniesYet: "Компаний пока нет",
    failedToLoad: "Не удалось загрузить компании",
    deleteConfirm: "Вы хотите удалить эту компанию?",
    deleteFailed: "Не удалось удалить компанию",
    operationFailed: "Операция не удалась",
    dataFormatError: "Ошибка формата данных",
    name: "Название компании *",
    status: "Статус",
    statusActive: "Активна",
    statusInactive: "Неактивна",
    searchPlaceholder: "Поиск (название, статус)...",
    clearFilters: "Очистить фильтры",
    copy: "Копировать",
    copySuffix: " (копия)",
    noCreatePermission: "Нет разрешения на создание компании",
    noUpdatePermission: "Нет разрешения на редактирование компании",
    noDeletePermission: "Нет разрешения на удаление компании",
    paginationRange: "{start}-{end} из {total}",
    paginationPage: "Страница {page} / {total}",
    allStatuses: "Все статусы",
    statusDistribution: "Распределение статусов компаний",
    show: "Показать",
    hide: "Скрыть",
    logo: "Логотип",
    logoEmpty: "Нет логотипа",
    uploadLogo: "Загрузить логотип",
    smtpEmailAccount: "Аккаунт SMTP",
    imapEmailAccount: "Аккаунт IMAP",
    smtpEmailId: "Аккаунт SMTP",
    imapEmailId: "Аккаунт IMAP",
  },

  // Emails
  emails: {
    title: "Почтовые Аккаунты",
    newEmail: "Новый аккаунт",
    editEmail: "Редактировать аккаунт",
    noEmailsYet: "Аккаунтов пока нет",
    failedToLoad: "Не удалось загрузить почтовые аккаунты",
    deleteConfirm: "Удалить этот аккаунт?",
    deleteConfirmMessage: "Вы хотите удалить аккаунт \"{name}\"?",
    deleteFailed: "Не удалось удалить",
    operationFailed: "Операция не удалась",
    dataFormatError: "Ошибка формата данных",
    name: "Название аккаунта",
    type: "Тип",
    host: "Хост",
    port: "Порт",
    user: "Имя пользователя",
    password: "Пароль",
    fromEmail: "Email отправителя",
    secure: "Защищенный (SSL/TLS)",
    secureConnection: "Защищенное соединение (SSL/TLS)",
    status: "Статус",
    statusActive: "Активен",
    statusInactive: "Неактивен",
    activate: "Активировать",
    deactivate: "Деактивировать",
    isActive: "Активен",
    searchPlaceholder: "Поиск (имя, хост, пользователь)...",
    clearFilters: "Очистить фильтры",
    copy: "Копировать",
    noCreatePermission: "Нет разрешения на создание аккаунта",
    noUpdatePermission: "Нет разрешения на редактирование аккаунта",
    noDeletePermission: "Нет разрешения на удаление аккаунта",
    paginationRange: "{start}-{end} из {total}",
    paginationPage: "Страница {page} / {total}",
    allStatuses: "Все статусы",
    allTypes: "Все типы",
    statusDistribution: "Распределение статусов аккаунтов",
    show: "Показать",
    hide: "Скрыть",
    nameRequired: "Имя аккаунта обязательно",
    hostRequired: "Хост обязателен",
    portRequired: "Порт обязателен",
    userRequired: "Имя пользователя обязательно",
    passwordRequired: "Пароль обязателен",
    leaveBlankToKeep: "Оставьте пустым, чтобы не менять",
    noData: "Нет данных",
    noEmailsMessage: "Аккаунты не найдены",
    passwordEditHint: "Оставьте пустым, чтобы не менять",
    noSearchResults: "Результаты не найдены",
    namePlaceholder: "напр., Поддержка или info@comp.ru",
    deleteConfirmTitle: "Удаление аккаунта",
  },

  // Login
  login: {
    title: "QubePro ERP",
    subtitle: "Система централизованного управления",
    heroTitle: "Управление бизнесом в одном месте",
    heroSubtitle: "QubePro ERP объединяет управление компаниями, организациями, пользователями и ролями на единой платформе.",
    languageToggleLabel: "Язык",
    turkish: "Турецкий",
    english: "Английский",
    email: "Email",
    password: "Пароль",
    emailPlaceholder: "example@domain.ru",
    emailHint: "Тенент определяется автоматически по домену",
    passwordPlaceholder: "••••••••",
    loginButton: "Войти",
    loggingIn: "Вход...",
    loginFailed: "Ошибка входа",
    darkMode: "Темная тема",
    lightMode: "Светлая тема",
    loginPageTitle: "Вход",
    submitButton: "Войти",
    featureTitle: "Планирование ресурсов предприятия",
    featureDescription: "Управляйте отношениями с клиентами, продажами, запасами и финансовыми процессами на единой платформе.",
    featureCard1Title: "Управление клиентами",
    featureCard1Description: "Отслеживайте клиентов, потенциальные продажи и деловые отношения из одного места.",
    featureCard2Title: "Продажи и заказы",
    featureCard2Description: "Легко управляйте предложениями, заказами и процессами продаж для увеличения доходов.",
    featureCard3Title: "Отчёты и аналитика",
    featureCard3Description: "Мониторинг бизнес-показателей с помощью отчётов в реальном времени для принятия обоснованных решений.",
    featureCard4Title: "Интеграция и настройки",
    featureCard4Description: "Настройте систему, интегрируйте другие инструменты и автоматизируйте бизнес-процессы.",
    pleaseWait: "Пожалуйста, подождите",
    serverConfiguring: "Настройка сервера, пожалуйста, подождите...",
    dbCreating: "Создание базы данных и конфигураций. Это может занять несколько секунд.",
    emailLabel: "Email",
    passwordLabel: "Пароль",
    emailPlaceholderFull: "Введите ваш email",
    passwordPlaceholderFull: "Введите ваш пароль",
    showPassword: "Показать",
    hidePassword: "Скрыть",
    emailRequired: "Email обязателен",
    passwordRequired: "Пароль обязателен",
    backendUnavailable: "Сервер недоступен. Попробуйте позже.",
    backendConnectFailed: "Ошибка подключения к серверу. Попробуйте позже.",
    backendConnectFailedDev: "Ошибка подключения. Убедитесь, что бэкенд запущен ({apiUrl}).",
    fieldEmail: "Email",
    fieldPassword: "Пароль",
    errors: {
      invalidCredentials: "Неверный email или пароль.",
      databaseUnavailable: "База данных недоступна или требуется настройка. Войдите снова.",
      accountInactive: "Ваш аккаунт неактивен. Обратитесь к администратору.",
      sessionExpired: "Сессия истекла. Пожалуйста, войдите снова.",
      tooManyAttempts: "Слишком много попыток. Попробуйте позже.",
      sessionTooLarge: "Данные сессии слишком велики. Попробуйте снова.",
    },
  },

  // DataSources
  dataSources: {
    title: "Источники Данных",
    subtitle: "Управление подключениями к базам данных",
    newDataSource: "Новый источник данных",
    editDataSource: "Редактировать источник данных",
    noDataSourcesYet: "Источники данных отсутствуют",
    failedToLoad: "Не удалось загрузить источники данных",
    deleteConfirm: "Вы хотите удалить этот источник данных?",
    deleteFailed: "Не удалось удалить",
    operationFailed: "Операция не удалась",
    dataFormatError: "Ошибка формата данных",
    name: "Отображаемое имя",
    driver: "Драйвер",
    server: "Сервер",
    port: "Порт",
    databaseName: "Имя БД",
    username: "Пользователь",
    password: "Пароль",
    schema: "Схема",
    sourceType: "Тип источника",
    source: "Источник",
    target: "Цель",
    sourceSystem: "Система-источник",
    targetSystem: "Целевая система",
    status: "Статус",
    statusActive: "Активен",
    statusInactive: "Неактивен",
    searchPlaceholder: "Поиск (имя, сервер, БД)...",
    clearFilters: "Очистить фильтры",
    copy: "Копировать",
    paginationRange: "{start}-{end} / {total}",
    paginationPage: "Страница {page} / {total}",
    allStatuses: "Все статусы",
    allTypes: "Все",
    statusDistribution: "Распределение статусов источников данных",
    show: "Показать",
    hide: "Скрыть",
    nameRequired: "Имя обязательно",
    serverRequired: "Адрес сервера обязателен",
    databaseRequired: "Имя базы данных обязательно",
    passwordRequired: "Пароль обязателен",
    testConnection: "Тест подключения",
    testing: "Тестирование...",
    testSuccess: "Подключение успешно!",
    testFailed: "Ошибка подключения: ",
    integratedSecurity: "Интегрированная безопасность",
    ssl: "SSL",
    connectionTimeout: "Тайм-аут подключения (сек)",
    description: "Описание",
    noCreatePermission: "Нет разрешения на создание источников",
    noUpdatePermission: "Нет разрешения на редактирование источников",
    noDeletePermission: "Нет разрешения на удаление источников",
  },

  aiProviders: {
    title: "Провайдеры ИИ",
    subtitle: "Управление моделями ИИ и интеграциями",
    newProvider: "Новый провайдер ИИ",
    editProvider: "Редактировать провайдера ИИ",
    noProvidersYet: "Нет данных",
    failedToLoad: "Не удалось загрузить провайдеров ИИ",
    deleteConfirm: "Вы уверены, что хотите удалить этого провайдера ИИ?",
    deleteFailed: "Не удалось удалить провайдера ИИ",
    operationFailed: "Операция не удалась",
    name: "Название провайдера *",
    provider: "Тип провайдера",
    baseUrl: "Базовый URL",
    apiKey: "Ключ API",
    description: "Описание",
    status: "Статус",
    statusActive: "Активен",
    statusInactive: "Неактивен",
    searchPlaceholder: "Поиск (имя, тип, URL)...",
    clearFilters: "Очистить фильтры",
    noCreatePermission: "У вас нет прав на создание провайдеров ИИ",
    statusDistribution: "Распределение статусов провайдеров ИИ",
    baseUrlPlaceholder: "напр., http://localhost:11434, https://api.custom.ai/v1",
    baseUrlEmptyDefault: "Оставьте пустым для значений по умолчанию",
    apiKeyPlaceholder: "Введите ключ API",
  },
};
